export const ApiPaths = {
    state: {
      Search: (countryId: number) => `/State/${countryId}`,
    },
    city: {
      Search: (countryId: number, stateId: number) => `/City/Search/${countryId}/${stateId}`,
    },
    businessUnit: {
      getById: (Id: number) => `/BusinessUnit/${Id}`,
      delete: `/BusinessUnit/Delete`,
      addUpdate: "/BusinessUnit/Save",
      getBusinessUnitList: `/BusinessUnit/Search`,
    },
    employee: {
      getById: (Id: number) => `/Employee/${Id}`,
      delete: `/Employee/Delete`,
      addUpdate: "/Employee/Save",
      addUpdateManager: "/Employee/SaveManager",
      getListBySearch: "/Employee/Search",
      getManager: "/Employee/GetManager",
      getHiringManagerByName: (search: string) => `/Employee/GetByName?search=${search}`,
      loadUserData: (UserId: number) => `/Employee/GetUserInfo/${UserId}`,
      UpdateStatus : `/Employee/ChangeStatus/`,
      loadManagerList: `Employee/GetUserSetup`,
    },
    costCenter: {
      getById: (Id: number) => `/CostCenter/${Id}`,
      delete: `/CostCenter/Delete`,
      addUpdate: "/CostCenter/Save",
      getListBySearch: `/CostCenter/Search`,
    },
    location: {
      getById: (Id: number) => `/Location/${Id}`,
      delete: `/Location/Delete`,
      addUpdate: "/Location/Save",
      getListBySearch: `/Location/Search`,
    },
    Logger:
    {
      addUpdate: "/Logger",
    }
  };
